import React, { useEffect, useRef, useState } from 'react';
import './Premium3DBanner.css';

const Premium3DBanner = () => {
  const containerRef = useRef(null);
  const [typingText, setTypingText] = useState('');
  const [currentSection, setCurrentSection] = useState(0);
  const [showPreview, setShowPreview] = useState(false);
  const [userName] = useState('ALEX THOMPSON');
  const [userTitle] = useState('Senior Full Stack Developer');

  const sections = [
    { text: 'Senior Full Stack Developer', field: 'title' },
    { text: 'Led development of scalable microservices', field: 'experience' },
    { text: 'React, Node.js, Python, AWS', field: 'skills' }
  ];

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const handleMouseMove = (e) => {
      const rect = container.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width;
      const y = (e.clientY - rect.top) / rect.height;
      
      const rotateY = (x - 0.5) * 8;
      const rotateX = (y - 0.5) * -8;
      
      container.style.setProperty('--mouse-x', x);
      container.style.setProperty('--mouse-y', y);
      container.style.setProperty('--rotate-x', `${rotateX}deg`);
      container.style.setProperty('--rotate-y', `${rotateY}deg`);
    };

    const handleMouseLeave = () => {
      container.style.setProperty('--rotate-x', '0deg');
      container.style.setProperty('--rotate-y', '0deg');
    };

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  // Switch between editor and preview every 8 seconds
  useEffect(() => {
    const switchInterval = setInterval(() => {
      setShowPreview(prev => !prev);
    }, 8000);

    return () => clearInterval(switchInterval);
  }, []);

  // Typing animation effect for editor view
  useEffect(() => {
    if (showPreview) return;
    
    const section = sections[currentSection];
    let currentChar = 0;
    
    const typingInterval = setInterval(() => {
      if (currentChar <= section.text.length) {
        setTypingText(section.text.slice(0, currentChar));
        currentChar++;
      } else {
        clearInterval(typingInterval);
        setTimeout(() => {
          setCurrentSection((prev) => (prev + 1) % sections.length);
        }, 2000);
      }
    }, 100);

    return () => clearInterval(typingInterval);
  }, [currentSection, showPreview]);

  return (
    <>
      {/* Static Mobile Banner - shown only on mobile */}
      <div className="mobile-banner-static">
        <div className="mobile-resume-card">
          <div className="mobile-card-header">
            <div className="mobile-profile-circle">
              <span>👤</span>
            </div>
            <div className="mobile-header-info">
              <h3>ALEX THOMPSON</h3>
              <p>Senior Full Stack Developer</p>
            </div>
          </div>
          <div className="mobile-card-body">
            <div className="mobile-section">
              <h4>SKILLS</h4>
              <div className="mobile-skills">
                <span>React</span>
                <span>Node.js</span>
                <span>Python</span>
                <span>AWS</span>
                <span>Docker</span>
                <span>TypeScript</span>
              </div>
            </div>
            <div className="mobile-section">
              <h4>EXPERIENCE</h4>
              <div className="mobile-line"></div>
              <div className="mobile-line short"></div>
            </div>
            <div className="mobile-section">
              <h4>EDUCATION</h4>
              <div className="mobile-line"></div>
              <div className="mobile-line short"></div>
            </div>
          </div>
          <div className="mobile-badge">
            <span>✨</span> AI-Powered
          </div>
        </div>
      </div>

      {/* 3D Banner - hidden on mobile */}
      <div className="premium-banner-wrapper desktop-only-banner" ref={containerRef}>
      <div className="banner-scene">
        {/* Depth Layers */}
        <div className="depth-layer layer-1">
          <div className="floating-orb orb-1"></div>
          <div className="floating-orb orb-2"></div>
          <div className="floating-orb orb-3"></div>
        </div>

        <div className="depth-layer layer-2">
          <div className="geometric-shape shape-cube"></div>
          <div className="geometric-shape shape-pyramid"></div>
          <div className="geometric-shape shape-sphere"></div>
        </div>

        <div className="depth-layer layer-3">
          {/* Show ONLY ONE card at a time */}
          <div className="card-stack-3d">
            {/* EDITOR VIEW - Shows first */}
            <div className={`resume-card-3d card-single ${!showPreview ? 'active' : 'hidden'}`}>
              <div className="card-glow primary-glow"></div>
              <div className="card-header">
                <div className="profile-circle">
                  <span className="profile-icon">👤</span>
                </div>
                <div className="header-lines">
                  <div className="typing-field">
                    <span className="typing-text">{typingText}</span>
                    <span className="cursor-blink">|</span>
                  </div>
                  <div className="field-label">{sections[currentSection].field}</div>
                </div>
              </div>
              <div className="card-body">
                <div className="editing-section">
                  <div className="edit-indicator">
                    <span className="edit-icon">✏️</span>
                    <span className="edit-text">Editing...</span>
                  </div>
                  <div className="content-line typing-line">
                    <div className="line-content"></div>
                    <span className="line-cursor"></span>
                  </div>
                  <div className="content-line">
                    <div className="line-content short"></div>
                  </div>
                </div>
                <div className="section-block">
                  <div className="block-line"></div>
                  <div className="block-line short"></div>
                </div>
                <div className="section-block">
                  <div className="block-line editing-highlight"></div>
                  <div className="block-line short"></div>
                </div>
              </div>
              <div className="holographic-shine"></div>
              <div className="premium-badge">
                <span className="badge-icon">✏️</span>
                <span className="badge-text">Editor</span>
              </div>
            </div>

            {/* PREVIEW VIEW - Shows after editor */}
            <div className={`resume-card-3d card-single ${showPreview ? 'active' : 'hidden'}`}>
              <div className="card-glow"></div>
              
              {/* Clean Professional Header */}
              <div className="preview-header-clean">
                <div className="preview-name-section">
                  <h1 className="preview-name-large">{userName}</h1>
                  <p className="preview-title-large">{userTitle}</p>
                </div>
                <div className="preview-contact-section">
                  <span className="contact-text">alex.thompson@email.com</span>
                  <span className="contact-divider">•</span>
                  <span className="contact-text">+1 (555) 123-4567</span>
                  <span className="contact-divider">•</span>
                  <span className="contact-text">San Francisco, CA</span>
                </div>
              </div>

              {/* Professional Summary */}
              <div className="preview-summary">
                <h3 className="summary-title">PROFESSIONAL SUMMARY</h3>
                <p className="summary-text">
                  Innovative Full Stack Developer with 8+ years building scalable applications and leading development teams.
                </p>
              </div>

              {/* Skills Section */}
              <div className="preview-section-clean">
                <h3 className="section-title-clean">SKILLS</h3>
                <div className="skills-grid">
                  <span className="skill-badge">React</span>
                  <span className="skill-badge">Node.js</span>
                  <span className="skill-badge">Python</span>
                  <span className="skill-badge">AWS</span>
                  <span className="skill-badge">Docker</span>
                  <span className="skill-badge">MongoDB</span>
                  <span className="skill-badge">TypeScript</span>
                  <span className="skill-badge">GraphQL</span>
                </div>
              </div>

              <div className="holographic-shine"></div>
            </div>
          </div>
        </div>

        <div className="depth-layer layer-5">
          {/* Particle System */}
          {[...Array(30)].map((_, i) => (
            <div
              key={i}
              className="particle-3d"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 5}s`,
                animationDuration: `${8 + Math.random() * 7}s`
              }}
            ></div>
          ))}
        </div>

        {/* Energy Waves */}
        <div className="energy-wave wave-1"></div>
        <div className="energy-wave wave-2"></div>

        {/* Grid Background */}
        <div className="cyber-grid"></div>
      </div>
      </div>
    </>
  );
};

export default Premium3DBanner;
